import getHelpers from './getHelpers'

const mapFields = (namespace, fields) =>
  getHelpers(namespace).mapFields(fields)

export default mapFields
